import { DatePicker, Segmented, Space } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export type Period = { from: string; to: string };
export type PresetKey = 'thisMonth' | 'lastMonth' | 'quarter' | 'ytd' | 'custom';

export function presetToPeriod(key: PresetKey): Period | null {
  const now = dayjs();
  switch (key) {
    case 'thisMonth':
      return { from: now.startOf('month').format('YYYY-MM-DD'), to: now.endOf('month').format('YYYY-MM-DD') };
    case 'lastMonth': {
      const m = now.subtract(1, 'month');
      return { from: m.startOf('month').format('YYYY-MM-DD'), to: m.endOf('month').format('YYYY-MM-DD') };
    }
    case 'quarter':
      return { from: now.startOf('quarter' as dayjs.OpUnitType).format('YYYY-MM-DD'), to: now.endOf('quarter' as dayjs.OpUnitType).format('YYYY-MM-DD') };
    case 'ytd':
      return { from: now.startOf('year').format('YYYY-MM-DD'), to: now.endOf('day').format('YYYY-MM-DD') };
    case 'custom':
      return null;
  }
}

export function PeriodFilter({
  preset,
  period,
  onPreset,
  onCustom,
}: {
  preset: PresetKey;
  period: Period;
  onPreset: (key: PresetKey) => void;
  onCustom: (p: Period) => void;
}) {
  const { t } = useTranslation();
  return (
    <Space wrap>
      <Segmented
        value={preset}
        onChange={(v) => onPreset(v as PresetKey)}
        options={[
          { value: 'thisMonth', label: t('owner.periods.thisMonth') },
          { value: 'lastMonth', label: t('owner.periods.lastMonth') },
          { value: 'quarter', label: t('owner.periods.quarter') },
          { value: 'ytd', label: t('owner.periods.ytd') },
          { value: 'custom', label: t('owner.periods.custom') },
        ]}
      />
      {preset === 'custom' && (
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          value={[dayjs(period.from), dayjs(period.to)]}
          onChange={(v) => {
            if (v && v[0] && v[1]) onCustom({ from: v[0].format('YYYY-MM-DD'), to: v[1].format('YYYY-MM-DD') });
          }}
        />
      )}
    </Space>
  );
}
